import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { LOCAL_STORAGE_KEYS } from '../../core/constants';
import { LoaderService } from '../../shared/services/loader.service';
import { Carrier } from '../../user-dashboard/shared/carrier.model';
import { CarrierService } from '../../user-dashboard/shared/carrier.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-reorder-loads',
  templateUrl: './reorder-loads.component.html',
  styleUrls: ['./reorder-loads.component.scss']
})
export class ReorderLoadsComponent implements OnInit {

  selectedCarrier: Carrier = null;
  carriers: Carrier[]      = [];
  canAssignVehicle         = true;

  constructor(
    private authService: AuthenticationService,
    private carrierService: CarrierService,
    private loader: LoaderService
  ) {
    if (this.authService.canManageCarriers()) {
      this.fetchCarriers();
    } else {
      this.fetchCarrierManager();
    }
  }

  fetchCarriers() {
    this.loader.startLoad();

    this.carrierService.getAll()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(carriers => {
        this.carriers        = carriers;
        this.selectedCarrier = carriers.find((carrier) => {
          return carrier.id === localStorage.getItem(LOCAL_STORAGE_KEYS.REORDER_LOADS_CARRIER);
        });
        if (!this.selectedCarrier) {
          this.selectedCarrier = this.carriers.length > 0 ? this.carriers[0] : null;
        }
        this.carrierChanged();
      });
  }

  fetchCarrierManager() {
    const userProfile = this.authService.getUserProfile();
    if (userProfile.carrier) {
      this.selectedCarrier = userProfile.carrier;
      this.carrierChanged();
    }

  }

  ngOnInit() {
  }

  carrierChanged() {
    this.canAssignVehicle = this.selectedCarrier && this.selectedCarrier.canAssignDriverInCmaweb();
  }
}
